/**
 * @generated SignedSource<<5221ce82a0ca8d897b368e3508f5bc00>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type RecapTemplateType = "BANT" | "CUSTOMER_SUCCESS" | "MEDDIC" | "SALES_DISCOVERY" | "SALES_FOLLOW_UP" | "SPICED";
export type HubspotSendNotesModalQuery$variables = {
  noteId: string;
};
export type HubspotSendNotesModalQuery$data = {
  readonly note: {
    readonly event?: {
      readonly isAllDay: boolean;
    } | null;
    readonly eventEnd?: string | null;
    readonly eventStart?: string | null;
    readonly meetingRecordings?: ReadonlyArray<{
      readonly activeSummary: {
        readonly activeRecapTemplate: RecapTemplateType | null;
        readonly id: string;
        readonly templatedRecaps: any | null;
      } | null;
      readonly id: string;
    }> | null;
    readonly title?: string;
  } | null;
};
export type HubspotSendNotesModalQuery = {
  response: HubspotSendNotesModalQuery$data;
  variables: HubspotSendNotesModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "noteId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "noteId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "eventStart",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "eventEnd",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAllDay",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "MeetingRecording",
  "kind": "LinkedField",
  "name": "meetingRecordings",
  "plural": true,
  "selections": [
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "MeetingRecordingSummary",
      "kind": "LinkedField",
      "name": "activeSummary",
      "plural": false,
      "selections": [
        (v6/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "templatedRecaps",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "activeRecapTemplate",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "HubspotSendNotesModalQuery",
    "selections": [
      {
        "alias": "note",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "event",
                "plural": false,
                "selections": [
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "type": "Note",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HubspotSendNotesModalQuery",
    "selections": [
      {
        "alias": "note",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Event",
                "kind": "LinkedField",
                "name": "event",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/)
                ],
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "type": "Note",
            "abstractKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "75b861415faf39a28f92c1d47236760a",
    "id": null,
    "metadata": {},
    "name": "HubspotSendNotesModalQuery",
    "operationKind": "query",
    "text": "query HubspotSendNotesModalQuery(\n  $noteId: ID!\n) {\n  note: node(id: $noteId) {\n    __typename\n    ... on Note {\n      title\n      eventStart\n      eventEnd\n      event {\n        isAllDay\n        id\n      }\n      meetingRecordings {\n        id\n        activeSummary {\n          id\n          templatedRecaps\n          activeRecapTemplate\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "db7fb2de901d2de1543978d718573358";

export default node;
